import { action, actionBound, observable, runInAction } from 'mobx';
import { API, FetchStatus } from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';

export class DealerSetRepresentationStore {
  @observable accessor status = FetchStatus.FETCHING;
  @observable accessor isDealer = false;
  @observable accessor state: { customerId: string | null; goto: string | null } = { customerId: null, goto: null };

  @actionBound
  public async init(customerId: string, goto: string) {
    this.state = { customerId, goto };
    this.status = FetchStatus.FETCHING;
    await this.verifyDealerAuth();
    return this.changeRepresentation();
  }

  private verifyDealerAuth = async () => {
    try {
      const sessionData = await API.get('/dealer/representation');
      runInAction(() => {
        this.isDealer = !!sessionData.data?.dealer;
      });
      if (!sessionData.data.dealer) {
        this.handleError();
      }
    } catch (e) {
      runInAction(() => {
        this.isDealer = false;
      });
      this.handleError(e);
    }
  };

  private changeRepresentation = async () => {
    const { customerId, goto } = this.state;
    if (!this.isDealer) {
      return;
    }
    try {
      await API.post(`/dealer/representation/${customerId}/`);
      if (goto) {
        this.handleSuccess(goto);
      } else {
        ErrorUtil.pushErrorToTeliaRumAndLogWithLocation('this.state.goto is null');
      }
    } catch (e) {
      this.handleError(e);
    }
  };

  @actionBound
  private handleSuccess(goto: string) {
    window.location.assign(goto);
    this.status = FetchStatus.FETCHED;
  }

  @actionBound
  private handleError(err?: any) {
    this.status = FetchStatus.ERROR;
    const { customerId, goto } = this.state;
    if (customerId && !isNaN(+customerId) && !!goto && this.isDealer && !!err) {
      ErrorUtil.pushErrorToTeliaRumAndLog(err);
    }
  }
}
